import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import { LocaleType } from "../models/CommonTypes";

import enSentara from "./en-sentara.json";
import enAvMed from "./en-avmed.json";


const resources = {
  enSentara,
  enAvMed,
};

i18n.use(initReactI18next).init({
  lng: LocaleType.SENTARA,
  resources,
  fallbackLng: [LocaleType.AVMED, LocaleType.SENTARA],
});
